export class PaypalPaymentModal {
  id: string;
  name: string;
  mobileNo: string;
  emailId: string;
  hospitalName: string;
  hospitalAddress: string;
  licenseType: number;
  licenseNo: string;
  validDays: number;
  validDevices: number;
  amount: number;
  deviceAmount: number;
  promoId: string;
  isUsed: boolean;
  productId: string;
  productType: number;
  productName: string = "";
  paypalTransactionId: string = "";
  trialAmount: string;
  fixedAmount: string;
}
